import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// Verificação contra robôs (Cloudflare Turnstile) no login e no "esqueci a senha".
// A caixinha só aparece quando as chaves foram coladas em Configurações → Escola → Segurança.
let carregando = null;
const carregarScript = () => carregando || (carregando = new Promise((ok, falha) => {
  const s = document.createElement("script");
  s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  s.async = true;
  s.onload = ok;
  s.onerror = () => { carregando = null; falha(new Error("turnstile")); };
  document.head.appendChild(s);
}));

export function useTurnstile(acao) {
  const caixaRef = useRef(null);
  const widget = useRef(null);
  const [site, setSite] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => { api.get("/auth/turnstile").then((r) => setSite(r.data.site_key || "")).catch(() => {}); }, []);
  useEffect(() => {
    if (!site || !caixaRef.current) return undefined;
    let vivo = true;
    carregarScript().then(() => {
      if (!vivo || !caixaRef.current || !window.turnstile) return;
      widget.current = window.turnstile.render(caixaRef.current, {
        sitekey: site, action: acao, language: "pt-br", theme: "light",
        callback: setToken, "expired-callback": () => setToken(""), "error-callback": () => setToken(""),
      });
    }).catch(() => {});
    return () => {
      vivo = false;
      if (widget.current !== null && window.turnstile) { window.turnstile.remove(widget.current); widget.current = null; }
    };
  }, [site, acao]);
  // O comprovante só vale uma vez: depois de cada tentativa, pede outro.
  const usar = () => {
    const t = token;
    if (widget.current !== null && window.turnstile) window.turnstile.reset(widget.current);
    setToken("");
    return t || undefined;
  };
  const caixa = site ? <div ref={caixaRef} className="flex justify-center min-h-[65px]" data-testid="turnstile" /> : null;
  return { caixa, falta: !!site && !token, usar };
}

export const AVISO_TURNSTILE = "Aguarde a verificação de segurança (a caixinha da Cloudflare) terminar e tente de novo.";

// Configurações → Escola → Segurança: colar as chaves do widget.
export function TurnstileConfig({ toast, Button, Input }) {
  const [t, setT] = useState(null);
  const [site, setSiteKey] = useState("");
  const [secret, setSecret] = useState("");
  const [salvando, setSalvando] = useState(false);
  useEffect(() => { api.get("/admin/turnstile").then((r) => { setT(r.data); setSiteKey(r.data.site_key); }).catch(() => setT({ site_key: "", ligada: false, dica: "" })); }, []);
  const salvar = async (corpo, msg) => {
    setSalvando(true);
    try { const r = await api.put("/admin/turnstile", corpo); setT(r.data); setSiteKey(r.data.site_key); setSecret(""); toast.success(msg); }
    catch (e) { toast.error(e.response?.data?.detail || "Não foi possível salvar."); }
    finally { setSalvando(false); }
  };
  if (!t) return null;
  return (
    <div className="space-y-4" data-testid="turnstile-config">
      <div>
        <div className="font-semibold text-slate-800">Proteção contra robôs (Cloudflare Turnstile)</div>
        <p className="text-sm text-slate-500 mt-1">Uma caixinha da Cloudflare no login e no "esqueci a senha" barra robôs que tentam adivinhar senhas. Para a aluna, quase sempre aparece "Sucesso!" sozinho.</p>
        <p className={`text-sm font-medium mt-2 ${t.ligada ? "text-[#1E9E2A]" : "text-slate-600"}`}>
          {t.ligada ? `✓ Ligada · Secret Key ${t.dica}` : "Desligada. Crie o widget em dash.cloudflare.com → Turnstile (domínios iepplataforma.com e www.iepplataforma.com, modo Managed) e cole as duas chaves."}
        </p>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="space-y-1.5"><label className="text-sm font-medium text-slate-800">Site Key (pública)</label>
          <Input value={site} onChange={(e) => setSiteKey(e.target.value)} placeholder="0x4AAAAAAA…" autoComplete="off" /></div>
        <div className="space-y-1.5"><label className="text-sm font-medium text-slate-800">Secret Key {t.ligada && <span className="text-xs text-slate-400">(em branco = manter a atual)</span>}</label>
          <Input type="password" value={secret} onChange={(e) => setSecret(e.target.value)} placeholder="0x4AAAAAAA…" autoComplete="off" /></div>
      </div>
      <div className="flex items-center gap-4">
        <Button type="button" disabled={salvando || !site.trim()} onClick={() => salvar({ site_key: site.trim(), secret: secret.trim() }, "Proteção contra robôs ligada.")}
          className="text-white rounded-full px-6" style={{ background: "#232D4F" }}>{salvando ? "Conferindo na Cloudflare…" : t.ligada ? "Salvar chaves" : "Ligar proteção"}</Button>
        {t.ligada && <button type="button" disabled={salvando} className="text-sm font-semibold text-red-600"
          onClick={() => { if (window.confirm("Desligar a proteção contra robôs? O login volta a funcionar sem a caixinha.")) salvar({ desligar: true }, "Proteção contra robôs desligada."); }}>Desligar</button>}
      </div>
      <p className="text-xs text-slate-400">Atenção: o domínio do widget na Cloudflare precisa ser exatamente iepplataforma.com. Se estiver errado, o login trava; aí é só corrigir lá.</p>
    </div>
  );
}
